// src/stone/illustrations/HandsUsingAppGray.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var HandsUsingAppGray = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64",
    ...props,
    children: [
      /* @__PURE__ */ jsx("rect", { width: 64, height: 64, fill: "currentcolor", rx: 8 }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M50.113 49.784c4.355-3.123 8.801-16.172 7.263-21.77-.394-1.432-2.706-2.04-4.493.682a73 73 0 0 0-2.28 3.71c-2.046-9.049-3.51-10.595-5.153-10.757-1.092-.113-4.157.677-2.604 5.927l.115.367c0 .007.007.018.01.024.002.007-.01-.004-.014-.005a9 9 0 0 0-.854-.328c-4.02-1.351-5.25 1.353-4.486 3.373.285.75.905 1.498 1.547 2.122a16.5 16.5 0 0 0 1.912 1.582q-.146.018-.29.047c-3.671.693-6.385 3.54-6.686 7.112-.402 4.724 2.284 8.46 6.066 9.598 3.707 1.12 7.003.43 9.947-1.684"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "m44.459 29.385.096-.235-.139-.085zM41.933 34.728l.143.473 2.377-5.797a8 8 0 0 0-.66-.394l-3.216 4.134q.618.843 1.356 1.584"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "m40.793 39.86 5.555 2.6a.84.84 0 0 0 1.12-.405l10.175-21.758a.844.844 0 0 0-.406-1.121l-5.555-2.602a.84.84 0 0 0-1.12.406L40.388 38.738a.844.844 0 0 0 .405 1.121"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "m40.796 39.856 5.554 2.602a.843.843 0 0 0 1.12-.41l6.873-14.695-9.196 1.207-4.757 10.175a.844.844 0 0 0 .406 1.12"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "m29.788 34.703 13.603 6.371a.984.984 0 0 0 1.31-.474l10.054-21.5a.986.986 0 0 0-.475-1.31l-13.603-6.372a.984.984 0 0 0-1.31.475l-10.054 21.5a.986.986 0 0 0 .475 1.31"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "m31.994 32.556 11.919 5.583 8.449-18.069-11.919-5.582z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "m33.1 33.074 10.813 5.065 8.45-18.069-10.814-5.064z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M46.969 16.606a.533.533 0 1 0 0-1.066.533.533 0 0 0 0 1.066"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M48.309 47.836c.943-1.705 4.963-6.66 2.245-10.598-1.37-1.986-3.055-3.451-4.32-4.17-.697-.339-2.06-.24-2.775.89-.705 1.186-.58 4.083 1.026 5.961-2.669-.61-5.582 1.112-6.552 3.03"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M48.309 47.837a.12.12 0 0 1-.085-.204c.607-.638 2.45-3.298 3.018-6.207a5.9 5.9 0 0 0-1.01-4.581q-.404-.575-.873-1.099a.121.121 0 0 1 .177-.165q.477.536.892 1.122a6.14 6.14 0 0 1 1.052 4.769c-.579 2.965-2.46 5.676-3.08 6.328a.12.12 0 0 1-.091.037"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M22.196 28.998c7.269-2.708 14.496-2.886 17.64-1.797 1.107.383 2.315 1.397 1.913 2.655-.437 1.367-1.659 1.877-2.634 2.186-2.471.778-6.221 1.075-9.752 2.387"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M26.672 42.128c-2.331 1.568-7.574 4.29-13.798 1.071-2.616-1.352-8.19-6.176-4.823-13.939 1.286-2.97 4.782-6.315 9.213-7.095 2.154-.38 4.348-.114 5.718 1.886 1.629-.284 5.176.664 6.19 3.138.298.862.58 1.884.906 2.735.483 1.26.866 2.585.836 3.935a10.7 10.7 0 0 1-.515 2.992c-.686 2.153-2.014 4.124-3.727 5.277"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M19.324 24.925a.121.121 0 0 1-.041-.235c1.54-.552 3.17-.817 4.805-.783a.12.12 0 1 1 0 .242 13.2 13.2 0 0 0-4.72.769.1.1 0 0 1-.044.007M23.146 28.72a.12.12 0 0 1-.041-.233c1.527-.547 4.421-1.169 6.003-1.49a.12.12 0 0 1 .125.184.12.12 0 0 1-.076.052c-1.58.322-4.456.939-5.971 1.48a.1.1 0 0 1-.04.008M30.4 36.852c-.612-.988-1.527-1.514-2.653-1.712a26 26 0 0 1 3.17-1.226 10.3 10.3 0 0 1-.517 2.938"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M30.209 37.22a.12.12 0 0 1-.106-.06c-.797-1.415-2.353-1.824-2.368-1.828a.12.12 0 0 1-.081-.053.12.12 0 0 1 .006-.14.12.12 0 0 1 .134-.04c.067.016 1.67.434 2.52 1.941a.12.12 0 0 1-.046.165.1.1 0 0 1-.06.016M37.933 43.07a.12.12 0 0 1-.108-.175c.598-1.18 1.893-2.26 3.38-2.815a.12.12 0 0 1 .08.226c-1.432.535-2.677 1.57-3.249 2.699a.12.12 0 0 1-.103.065"
        }
      )
    ]
  }
);
var HandsUsingAppGray_default = HandsUsingAppGray;

export {
  HandsUsingAppGray,
  HandsUsingAppGray_default
};
